import React from 'react';

const BlogTrail = ()=> {
    return (
        <div className="gridRadioDisplay" id="trail"> 
            <div className="_x">
                <h1>Lorem ipsum dolor</h1>
            </div>
            <div className="BG1top _a">
                <div className="BG2top"></div>
            </div>
            <div className="BG1top _b">
                <div className="BG2top"></div>
            </div>
            <div className="BG1top _e">
                <div className="BG2top"></div>
            </div>
            <div className="BG1bottom _f">
                <div className="BG2bottom"></div>
            </div>
            <div className="BG1bottom _h">
                <div className="BG2bottom"></div>
            </div>
            <div className="BG1bottomAlt _i">
                <div className="BG2bottom"></div>
            </div>
            
            <div className="_y"><h3 id="topText">Lorem ipsum dolor</h3></div>
            <div className="_z"><h3 id="bottomText">Lorem ipsum dolor</h3></div>
        </div>
    )
}

export default BlogTrail;